import React from 'react'

const Reorder = () => {
 
  return (
   <div className="min-h-[50vh] w-full max-w-4xl mx-auto px-4 py-6 sm:py-10">
    <div className="bg-white border rounded-xl p-4 sm:p-6 text-gray-700 text-sm sm:text-base">
    THis is Reorder Page
    </div>
   </div>
    
  )
}

export default Reorder